import React, {useCallback, useRef} from "react";
import useInView from "../../hooks/useInView";
import "./Reveal.scss";

const VARIANTS = {
  up: "reveal-up",
  left: "reveal-left",
  right: "reveal-right",
  scale: "reveal-scale"
};

export default function Reveal({
  children,
  className = "",
  direction = "up",
  delay = 0,
  as: Tag = "div"
}) {
  const ref = useRef(null);
  const inView = useInView(ref);
  const doneRef = useRef(false);

  const onDone = useCallback(e => {
    if (e.target !== e.currentTarget || doneRef.current) return;
    doneRef.current = true;
    e.currentTarget.classList.add("reveal-done");
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${VARIANTS[direction] || VARIANTS.up}${
        inView ? " is-visible" : ""
      }${className ? ` ${className}` : ""}`}
      style={delay ? {"--reveal-delay": `${delay}ms`} : undefined}
      onTransitionEnd={onDone}
    >
      {children}
    </Tag>
  );
}
